import { useViewport } from 'hooks/corporatiu/useViewport';
import Icona from 'components/corporatiu/Icona';
import Enllac from 'components/corporatiu/Enllac';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './titol.module.scss';

const Titol = (props) => {
    const {
        titol,
        tipus,
        tag,
        tema,
        className,
        sliderId,
        icona,
        iconaTitol,
        text,
        estil,
        mostrarBotoMesItems,
        estilTitolMes,
        link,
        linkTipus,
        slug,
        fons,
        subtitol,
        idDom,
        midaIcona = 40,
        iconaBlanc = false
    } = props;

    const { zoomNavigator } = useViewport();

    const route = {
        href: link,
        type: linkTipus,
        slug: slug
    };

    let Tag = tag;

    if (__isEmpty(Tag)) {
        if (tipus === 'seccio') {
            Tag = 'h2';
        } else {
            Tag = 'h1';
        }
    }

    const _netejaTitolTira = () => {
        if (!titol) return titol;
        return titol.replace(/\*\[([^\][]*)]\*/g, '').trim();
    };

    const styleTitol = clsx({
        [styles.titol]: true,
        [styles[tipus]]: !__isEmpty(tipus),
        [styles[tema]]: !__isEmpty(tema),
        [styles[estil]]: !__isEmpty(estil),
        [styles.ambZoom]: zoomNavigator > 2,
        [[className]]: !__isEmpty(className)
    });

    const styleTitolMes = clsx({
        [styles.titolMesWrapper]: true,
        [styles[tipus]]: !__isEmpty(tipus),
        [styles.titolMes]: mostrarBotoMesItems,
        [styles[estilTitolMes]]: !__isEmpty(estilTitolMes),
        [styles[fons]]: !!fons
    });

    const styleIconaTitol = clsx({
        [styles.contentIconaTitol]: true,
        [styles[`content-icona-${estil}`]]: !__isEmpty(estil)
    });

    if (mostrarBotoMesItems) {
        return (
            <div className={styleTitolMes}>
                {titol && (
                    <Tag className={styleTitol} {...(idDom && { id: idDom })}>
                        {_netejaTitolTira()}
                    </Tag>
                )}
                <span className={styles.titolMes_tot}>
                    <Enllac route={route} className={styles.titolMes_link}>
                        {text}
                    </Enllac>
                    {icona && (
                        <Icona
                            icona={icona}
                            isBlanc={estilTitolMes === 'blanc'}
                            className={`iconaTitol ${styles.titolMes_icona}`}
                        />
                    )}
                </span>
            </div>
        );
    }

    if (sliderId) {
        return (
            <Tag className={styleTitol} id={sliderId} {...(idDom && { id: idDom })}>
                {_netejaTitolTira()}
            </Tag>
        );
    }

    if (iconaTitol) {
        return (
            <>
                <div className={styleIconaTitol}>
                    <span className={styles.iconaTitol} data-testid={`icona-${iconaTitol}`}>
                        <Icona icona={iconaTitol} alt={iconaTitol} mida={midaIcona} isBlanc={iconaBlanc} inline={true} />
                    </span>
                    <Tag className={styleTitol} {...(idDom && { id: idDom })}>
                        {_netejaTitolTira()}
                    </Tag>
                </div>
                {subtitol && (
                    <div className={styles.subtitolWrapper}>
                        <p>{subtitol}</p>
                    </div>
                )}
            </>
        );
    }

    return (
        <>
            <Tag className={styleTitol} {...(idDom && { id: idDom })}>
                {_netejaTitolTira()}
            </Tag>
            {subtitol && (
                <div className={styles.subtitolWrapper}>
                    <p>{subtitol}</p>
                </div>
            )}
        </>
    );
};

export default Titol;
